var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompleted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3412 14.4313C15.4713 14.5615 15.4713 14.7725 15.3412 14.9027C15.211 15.0329 14.9999 15.0329 14.8698 14.9027L15.3412 14.4313ZM8.10547 7.66699L7.86977 7.43129L8.10547 7.19559L8.34117 7.43129L8.10547 7.66699ZM7.4388 12.667L7.6745 12.9027L7.4388 13.1384L7.2031 12.9027L7.4388 12.667ZM4.4388 9.66699L4.2031 9.43129L4.4388 9.19559L4.6745 9.43129L4.4388 9.66699ZM1.34117 13.236C1.211 13.3662 0.999941 13.3662 0.869766 13.236C0.739592 13.1059 0.739592 12.8948 0.869766 12.7646L1.34117 13.236ZM8.4388 11.667L8.2031 11.4313L8.4388 11.1956L8.6745 11.4313L8.4388 11.667ZM10.1055 13.3337L10.3412 13.5694L10.1055 13.8051L9.86977 13.5694L10.1055 13.3337ZM8.34117 7.90269L5.34117 10.9027L4.86977 10.4313L7.86977 7.43129L8.34117 7.90269ZM7.2031 12.9027L4.2031 9.90269L4.6745 9.43129L7.6745 12.4313L7.2031 12.9027ZM4.6745 9.90269L1.34117 13.236L0.869766 12.7646L4.2031 9.43129L4.6745 9.90269ZM7.2031 12.4313L8.2031 11.4313L8.6745 11.9027L7.6745 12.9027L7.2031 12.4313ZM8.6745 11.4313L10.3412 13.098L9.86977 13.5694L8.2031 11.9027L8.6745 11.4313ZM14.8698 14.9027L11.7031 11.736L12.1745 11.2646L15.3412 14.4313L14.8698 14.9027ZM11.7031 11.736L7.86977 7.90269L8.34117 7.43129L12.1745 11.2646L11.7031 11.736ZM9.86977 13.098L11.7031 11.2646L12.1745 11.736L10.3412 13.5694L9.86977 13.098Z",
    fill: "#202635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.43896 9.66634V1.33301",
    stroke: "#202635",
    strokeWidth: 0.666667,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.77197 2H9.43864L8.10531 3.33333L9.43864 4.66667H4.77197V2Z",
    fill: "#202635"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.cefaaa3d.svg";
export { ForwardRef as ReactComponent };